import men from "../../Assets/Images/Services/men.png"
import women from "../../Assets/Images/Services/women.png"
import grad from "../../Assets/Images/Services/grad.png"
import youth from "../../Assets/Images/Services/youth.png"
import bible from "../../Assets/Images/Services/bible.png"
import kids from "../../Assets/Images/Services/kids.png"
import catechesis from "../../Assets/Images/Services/catechseis.png"
import prayer from "../../Assets/Images/Services/prayer.png"
import hymns from "../../Assets/Images/Services/HymnsClass.png"

export const services = [
    {
        image: catechesis,
        text: "Catechesis meeting is every Sunday at 11 am"
    },

    {
        image: grad,
        text: "Collage and Young Professional meeting is every Sunday at 5 pm"
    },

    {
        image: bible,
        text: "Bible Study is every Tuesday at 7 pm"
    },

    {
        image: prayer,
        text: "Prayer meeting is every Wednesday at 8pm"
    },

    {
        image: youth,
        text: "Middle school and high school youth meeting is every Friday at 7 pm"
    },

    {
        image: hymns,
        text: "Hymns classes is every Saturday at 4:30 pm"
    },

    {
        image: kids,
        text: "Kids Club is every Saturday at 5 pm"
    },

    {
        image: men,
        text: "Men's fellowship is the 4th Thursday of each month"
    },
    {
        image: women,
        text: "Women's fellowship "
    },






];
